import {
  ClickAwayListener,
  Grow,
  Icon,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  PopperPlacementType,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import { CheckIcon, IconProps } from "@tc/ui-dfe/icons"
import { ComponentType } from "react"

export interface ButtonPoperOption {
  value: string
  key?: string
  icon?: ComponentType<IconProps>
}

export interface ButtonProperProps {
  isOpen: boolean
  anchorEl?: HTMLElement
  options: ButtonPoperOption[]
  placement?: PopperPlacementType
  selectedIndex?: number
  dividerIndexes?: number[]
  onOptionClick?: (index: number) => void
  onClickAway?: (event: Event) => void
}

export const ButtonPoper = ({
  isOpen,
  anchorEl,
  options,
  selectedIndex,
  dividerIndexes = [],
  placement = "bottom-end",
  onClickAway,
  onOptionClick,
}: ButtonProperProps) => {
  const theme = useTheme()
  const mdUp = useMediaQuery(theme.breakpoints.up("md"))
  return (
    <Popper
      data-testid="test-buttonPoper"
      sx={{
        zIndex: 1,
      }}
      open={isOpen}
      anchorEl={anchorEl}
      role={undefined}
      transition
      disablePortal
      placement={placement}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              // TODO add more cases
              placement === "bottom-end" ? "right top" : "left top",
          }}
        >
          <Paper sx={{ borderRadius: 0.5 }}>
            <ClickAwayListener
              onClickAway={onClickAway ? onClickAway : () => {}}
            >
              <MenuList data-testid="test-buttonPoper-menu" autoFocusItem>
                {options.map((option, index) => {
                  return (
                    <MenuItem
                      key={`buttonPoper-menuItem-${index}`}
                      data-testid={`test-buttonPoper-menuItem-${index}`}
                      divider
                      onClick={() => {
                        if (selectedIndex !== index) {
                          // setSelectedIndex(index)
                          onOptionClick && onOptionClick(index)
                        }
                      }}
                      sx={{
                        display: "flex",
                        ...(!mdUp
                          ? {
                              fontWeight: 600,
                              py: 1,
                              px: 2,
                              gap: 1.5,
                              "& .MuiSvgIcon-root, & .MuiIcon-root": {
                                width: 24,
                                height: 24,
                              },
                            }
                          : {}),
                      }}
                    >
                      {selectedIndex === index ? <CheckIcon /> : <Icon />}
                      {option.icon && <option.icon />}
                      <Typography
                        // TODO confirm boundary
                        variant={mdUp ? "body1" : "h6"}
                        color="textPrimary"
                      >
                        {option.value}
                      </Typography>
                    </MenuItem>
                  )
                })}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
}
